<template>
  <van-overlay @click="bindClose" :show="show" z-index="22">
    <div class="toast" @click.stop>
      <img
        class="toast-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/92a9140a09baf8dd988f7ffc60905938.png"
        alt=""
      />
      <div class="title">预约成功</div>
      <div class="time"
        >您已成功预约<span class="bold"
          >{{ sDate | filterTime }}-{{ eDate | filterTime }}</span
        >的<br />营养师餐卡点评服务 请耐心等待</div
      >
      <div class="desc"
        ><span class="bold">请添加您的私人陪伴官</span><br />
        提供预约信息 为您开通服务</div
      >
      <div class="consult"
        ><img
          class="icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/94f3f1ac37643517ad5d0e6b35b7aaa9.png"
        />若已添加，可直接咨询
      </div>
      <div class="btn" @click="bindAddCustomer">去添加</div>
      <div class="close iconfont icon-cha" @click="bindClose"></div>
    </div>
  </van-overlay>
</template>
<script>
export default {
  props: {
    sDate: {
      type: String,
      default: ''
    },
    eDate: {
      type: String,
      default: ''
    }
  },
  filters: {
    filterTime(str) {
      return str.replace(/-/g, '.')
    }
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    bindClose() {
      this.$emit('close')
    },
    //跳转客服
    bindAddCustomer() {
      this.$emit('consult')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  width: 295px;
  margin: 0 auto;
  padding: 70px 20px 20px;
  background: #ffffff;
  border-radius: 12px;

  .close {
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border: 1px solid #fff;
    position: absolute;
    left: 50%;
    bottom: -40px;
    transform: translate(-50%, 0%);
  }

  .toast-image {
    position: absolute;
    left: 0%;
    top: -29px;
    width: 100%;
    height: 82px;
    object-fit: contain;
  }

  .title {
    margin-bottom: 12px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 26px;
  }

  .time {
    margin-bottom: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }

  .bold {
    font-weight: 600;
  }

  .desc {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    margin-bottom: 36px;
  }

  .consult {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 14px;
    margin-bottom: 8px;

    .icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }

  .btn {
    height: 44px;
    background: linear-gradient(180deg, #fee1c3 0%, #ffcfa2 100%);
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #5c311f;
    line-height: 44px;
  }
}
</style>
